var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, unref as _unref, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("iframe", {
    style: { "display": "none" },
    onload: "resizeTextarea(1,7)"
}, null, -1);
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "profile_entry"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h2", null, "基本情報登録", -1);
const _hoisted_6 = { class: "inner" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" メール"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "non_public" }, "非公開")
], -1);
const _hoisted_8 = { class: "dd_l" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" パスワード"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "non_public" }, "非公開")
], -1);
const _hoisted_10 = { class: "f_pass w60" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", {
    id: "buttonEye_1",
    class: "fa fa-eye",
    onclick: "pushHideButton(1)"
}, null, -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", null, "※半角英数字12文字以上", -1);
const _hoisted_13 = {
    key: 0,
    class: "err"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 確認用パスワード"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "non_public" }, "非公開")
], -1);
const _hoisted_15 = { class: "f_pass w60" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("span", {
    id: "buttonEye_2",
    class: "fa fa-eye",
    onclick: "pushHideButton(2)"
}, null, -1);
const _hoisted_17 = {
    key: 0,
    class: "err"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 表示名"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_19 = {
    key: 0,
    class: "err"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 業種"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "　", -1);
const _hoisted_22 = ["value"];
const _hoisted_23 = {
    key: 0,
    class: "err"
};
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 職種"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "optionally" }, "任意"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 会社概要"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "optionally" }, "任意"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 年商"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "optionally" }, "任意"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "　", -1);
const _hoisted_28 = ["value"];
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 社員数"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "optionally" }, "任意"),
    /*#__PURE__*/ _createElementVNode("span", { class: "public" }, "公開")
], -1);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "　", -1);
const _hoisted_31 = ["value"];
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode(" 料金プランを"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createTextVNode("お選びください"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "non_public" }, "非公開")
], -1);
const _hoisted_33 = { class: "tab-wrap" };
const _hoisted_34 = ["value", "id"];
const _hoisted_35 = ["for"];
const _hoisted_36 = { class: "form-plan tab-content" };
const _hoisted_37 = { class: "plan-title" };
const _hoisted_38 = { class: "plan-main" };
const _hoisted_39 = { class: "plan-main-top" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("p", null, "基本料金(月額)", -1);
const _hoisted_41 = { class: "plan-money" };
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("span", { class: "plan-type" }, "円(税込)", -1);
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("div", { class: "plan-main-top" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "基本料金(月額)")
], -1);
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("p", { class: "plan-money" }, [
    /*#__PURE__*/ _createTextVNode(" 無料"),
    /*#__PURE__*/ _createElementVNode("span", { class: "plan-type" }, "(相談は不可)")
], -1);
const _hoisted_45 = {
    key: 0,
    class: "plan-add"
};
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("p", null, "追加相談", -1);
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("div", { class: "plan-article" }, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode(" ※日割りできないので、初月の基本料金は、申込日に応じて次の対応とさせて頂きます。"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode(" 申込日が1～15日：基本料金を全額支払い（質問チケットは基本と同数）"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode(" 申込日が16～末日：基本料金を半額支払い（質問チケットは基本の半数） ")
    ])
], -1);
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("p", { class: "plan-alart" }, "※このお申込後に、キャンセルすることはできません。", -1);
const _hoisted_49 = {
    key: 0,
    class: "err"
};
const _hoisted_50 = { class: "bt_box" };
const _hoisted_51 = {
    key: 0,
    class: "err_list"
};
const _hoisted_52 = ["onClick"];
import { ref, reactive, watch, onBeforeMount, onMounted, onUnmounted, nextTick } from 'vue';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import { PlanCategory } from '@util/Consts';
import JobsModal from '@component/Modals/JobModal.vue';
import { isObjEmpty } from '@util/Common';
export default /*#__PURE__*/ _defineComponent({
    __name: 'profile_entry',
    props: {
        common: null,
        errors: null,
        email: null,
        plan_id: null
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const validate = reactive({ shot: false });
        const form = InertiaUtil.getForm({
            name: '',
            email: props.email,
            password: '',
            password_confirmation: '',
            industry_id: null,
            job_id: null,
            job_group_id: null,
            other_job_name: '',
            company_profile: '',
            annual_sale_id: null,
            employee_id: null,
            plan_id: props.plan_id,
        }, (_a = props.common.path) !== null && _a !== void 0 ? _a : '');
        const tempForm = reactive({
            name: form.name,
            email: props.email,
            password: '',
            password_confirmation: '',
            industry_id: form.industry_id,
            job_id: form.job_id,
            job_group_id: form.job_group_id,
            other_job_name: form.other_job_name,
            company_profile: form.company_profile,
            annual_sale_id: form.annual_sale_id,
            employee_id: form.employee_id,
            plan_id: (_b = form.plan_id) !== null && _b !== void 0 ? _b : props.plan_id,
        });
        const industryOptions = ref([]);
        const jobOptions = ref([]);
        const annualSaleOptions = ref([]);
        const employeesOptions = ref([]);
        const planOptions = ref([]);
        // 文字数チェック
        watch(() => tempForm.name, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.password, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.password = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.password_confirmation, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.password_confirmation = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.company_profile, (value) => {
            if (Alert.charLimitTextArea(value)) {
                tempForm.company_profile = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => tempForm, () => PageExitConfirm.addEvent(), { deep: true });
        const onSubmit = () => {
            form.name = tempForm.name;
            form.email = tempForm.email;
            form.password = tempForm.password;
            form.password_confirmation = tempForm.password_confirmation;
            form.industry_id = tempForm.industry_id;
            form.job_id = tempForm.job_id;
            form.job_group_id = tempForm.job_group_id;
            form.other_job_name = tempForm.other_job_name;
            form.company_profile = tempForm.company_profile;
            form.annual_sale_id = tempForm.annual_sale_id;
            form.employee_id = tempForm.employee_id;
            form.plan_id = tempForm.plan_id;
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('questioner.register.verify'), () => { validate.shot = true; });
        };
        const onSelectedJob = (job) => {
            var _a;
            tempForm.job_group_id = job.job_group_id;
            tempForm.job_id = job.job_id;
            tempForm.other_job_name = (_a = job.other_job_name) !== null && _a !== void 0 ? _a : '';
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            const [industries, jobs, annualSales, employees, plans] = yield Promise.all([
                axios.get('industries').then(res => res.data).catch(e => []),
                axios.get('jobs').then(res => res.data).catch(e => []),
                axios.get('annual-sales').then(res => res.data).catch(e => []),
                axios.get('employees').then(res => res.data).catch(e => []),
                axios.get('plans').then(res => res.data).catch(e => []),
            ]);
            industryOptions.value = industries;
            jobOptions.value = jobs;
            annualSaleOptions.value = annualSales;
            employeesOptions.value = employees;
            planOptions.value = plans;
        }));
        onMounted(() => {
            validate.shot = isObjEmpty(props.errors);
            nextTick(() => {
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("form", null, [
                                    _createElementVNode("dl", null, [
                                        _hoisted_7,
                                        _createElementVNode("dd", _hoisted_8, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((props.email) = $event)),
                                                class: "w60 read-only",
                                                type: "text",
                                                readonly: ""
                                            }, null, 512), [
                                                [_vModelText, props.email]
                                            ])
                                        ]),
                                        _hoisted_9,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_10, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((tempForm.password) = $event)),
                                                    class: "wmax",
                                                    type: "password",
                                                    id: "textPassword_1",
                                                    placeholder: "半角英数字12文字以上",
                                                    autocomplete: "new-password"
                                                }, null, 512), [
                                                    [_vModelText, tempForm.password]
                                                ]),
                                                _hoisted_11
                                            ]),
                                            _hoisted_12,
                                            (validate.shot && ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.password))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(props.errors.password), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_14,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((tempForm.password_confirmation) = $event)),
                                                    class: "wmax",
                                                    type: "password",
                                                    id: "textPassword_2",
                                                    placeholder: "再パスワードを入力",
                                                    autocomplete: "new-password"
                                                }, null, 512), [
                                                    [_vModelText, tempForm.password_confirmation]
                                                ]),
                                                _hoisted_16
                                            ]),
                                            (validate.shot && ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.password_confirmation))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(props.errors.password_confirmation), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_18,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((tempForm.name) = $event)),
                                                class: "w40",
                                                type: "text",
                                                placeholder: "例：山田 太郎",
                                                autocomplete: "off"
                                            }, null, 512), [
                                                [_vModelText, tempForm.name]
                                            ]),
                                            (validate.shot && ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.name))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(props.errors.name), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_20,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((tempForm.industry_id) = $event)),
                                                id: "sel_1",
                                                class: "w40"
                                            }, [
                                                _hoisted_21,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryOptions.value, (industry) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: industry.id
                                                    }, _toDisplayString(industry.name), 9, _hoisted_22));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, tempForm.industry_id]
                                            ]),
                                            (validate.shot && ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.industry_id))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(props.errors.industry_id), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_24,
                                        _createElementVNode("dd", null, [
                                            _createVNode(JobsModal, {
                                                options: jobOptions.value,
                                                form: tempForm,
                                                onSelected: onSelectedJob
                                            }, null, 8, ["options", "form"])
                                        ]),
                                        _hoisted_25,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((tempForm.company_profile) = $event)),
                                                placeholder: "入力してください",
                                                id: "textarea_1",
                                                oninput: "resizeTextarea(1,7)"
                                            }, null, 512), [
                                                [_vModelText, tempForm.company_profile]
                                            ])
                                        ]),
                                        _hoisted_26,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((tempForm.annual_sale_id) = $event)),
                                                id: "sel_2",
                                                class: "w60"
                                            }, [
                                                _hoisted_27,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(annualSaleOptions.value, (sales) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: sales.id
                                                    }, _toDisplayString(sales.name), 9, _hoisted_28));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, tempForm.annual_sale_id]
                                            ])
                                        ]),
                                        _hoisted_29,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((tempForm.employee_id) = $event)),
                                                id: "sel_3",
                                                class: "w50"
                                            }, [
                                                _hoisted_30,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeesOptions.value, (employee) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: employee.id
                                                    }, _toDisplayString(employee.name), 9, _hoisted_31));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, tempForm.employee_id]
                                            ])
                                        ]),
                                        _hoisted_32,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_33, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planOptions.value, (option, index) => {
                                                    var _a, _b, _c, _d;
                                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((tempForm.plan_id) = $event)),
                                                            value: option.id,
                                                            id: `TAB-${index}`,
                                                            type: "radio",
                                                            name: "TAB",
                                                            class: "tab-switch"
                                                        }, null, 8, _hoisted_34), [
                                                            [_vModelRadio, tempForm.plan_id]
                                                        ]),
                                                        _createElementVNode("label", {
                                                            class: "tab-label",
                                                            for: `TAB-${index}`
                                                        }, _toDisplayString(option.name), 9, _hoisted_35),
                                                        _createElementVNode("div", _hoisted_36, [
                                                            _createElementVNode("p", _hoisted_37, _toDisplayString(`${option.name}プラン`), 1),
                                                            _createElementVNode("div", _hoisted_38, [
                                                                (option.id !== _unref(PlanCategory).FREE_PLAN)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                        _createElementVNode("div", _hoisted_39, [
                                                                            _hoisted_40,
                                                                            _createElementVNode("p", null, "(相談" + _toDisplayString(option === null || option === void 0 ? void 0 : option.monthly_question_count) + "件以内/月)", 1)
                                                                        ]),
                                                                        _createElementVNode("p", _hoisted_41, [
                                                                            _createTextVNode(_toDisplayString((_b = ((_a = option === null || option === void 0 ? void 0 : option.monthly_amount) !== null && _a !== void 0 ? _a : 0)) === null || _b === void 0 ? void 0 : _b.toLocaleString()), 1),
                                                                            _hoisted_42
                                                                        ])
                                                                    ], 64))
                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        _hoisted_43,
                                                                        _hoisted_44
                                                                    ], 64))
                                                            ]),
                                                            (option.is_allowed_additional_question)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                                    _hoisted_46,
                                                                    _createElementVNode("p", null, _toDisplayString((_d = ((_c = option === null || option === void 0 ? void 0 : option.additional_question_amount) !== null && _c !== void 0 ? _c : 0)) === null || _d === void 0 ? void 0 : _d.toLocaleString()) + "円 / 件(税込)", 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (option.id !== _unref(PlanCategory).FREE_PLAN)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _hoisted_47,
                                                                    _hoisted_48
                                                                ], 64))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ], 64));
                                                }), 256))
                                            ]),
                                            (validate.shot && ((_e = props.errors) === null || _e === void 0 ? void 0 : _e.price_id))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(props.errors.price_id), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                        (validate.shot)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                                    return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                                }), 256))
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    id: "submit-button",
                                                    onClick: _withModifiers(onSubmit, ["prevent"])
                                                }, "確認", 8, _hoisted_52)
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
